
import api from 'api';

export const types = {
  REQUEST: 'app/profile/REQUEST',
  RECEIVE: 'app/profile/RECEIVE',
};

function receive(profile) {
  return {
    type: types.RECEIVE,
    payload: {
      profile,
      isFetching: false,
    },
  };
}

function request(profileId) {
  return (dispatch) => {
    return api.profileApi.get(profileId).then((profile) => {
      dispatch(receive(profile));
    });
  }
}

const actions = {
  request,
  receive,
};

export default actions;
